import axios from "axios";

export default axios.create({
  baseURL: "https://d5d6dnd77nd3nme64mb2.apigw.yandexcloud.net/getData"
});